<script>

    import { toast } from 'bulma-toast'
    import { userStore, prepaidsStore, modalStore, adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import PrepaidsService from '../$services/prepaids.service'
    import DateMethods from '../$methods/date.methods.js'
    import NumeralMethods from '../$methods/numeral.methods'

    import Table from '../$components/table.svelte'
    import Button from '../$components/button.svelte'
    import ButtonModal from '../$components/button.modal.svelte'

    import PrepaidsTotal from './component.prepaids.total.svelte'

    let loading = false

    getPrepaids()

    async function getPrepaids() {

        loading = true
        const resp = await PrepaidsService.getPrepaids($userStore._id, 'user')
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        prepaidsStore.set(resp.data)
    }

</script>

<PrepaidsTotal />

<Table items={ $prepaidsStore.length } { loading } skeletonCols={9}>
    <div slot="header" class="header-filters">
        {#if isPermission($adminStore, 'UsersView.Prepaid.Create')}
            <div class="header-actions">
                <ButtonModal modalId="prepaid_create_modal" text="Agregar" icon="plus" />
            </div>
        {/if}
    </div>
    <thead slot="thead">
        <tr>
            <th>#</th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-clipboard-check"></i></span>
                    <span>Estatus</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-truck"></i></span>
                    <span>Proveedor</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-shipping-fast"></i></span>
                    <span>Servicio</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-weight"></i></span>
                    <span>Peso</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-calculator"></i></span>
                    <span>Total</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-dollar-sign"></i></span>
                    <span>Precio</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-chart-bar"></i></span>
                    <span>Usadas</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-ellipsis-v"></i></span>
                    <span>Acciones</span>
                </span>
            </th>
        </tr>
    </thead>
    <tbody slot="tbody">
        {#each $prepaidsStore as prepaid, index}
            <tr>
                <td>{ index + 1 }</td>
                <td>{ prepaid.shipments.length < prepaid.shipmentsTotal && DateMethods.isAfter(prepaid.expired) ? 'Activo' : 'Expiró' }</td>
                <td>{ prepaid.provider }</td>
                <td>{ prepaid.service }</td>
                <td>{ prepaid.volumetricMin }Kg a { prepaid.volumetricMax }kg</td>
                <td>{ prepaid.shipmentsTotal }</td>
                <td>{ prepaid.shipmentPrice != null ? NumeralMethods.cash(prepaid.shipmentPrice) : '—' }</td>
                <td>{ prepaid.shipments.length }</td>
                <td>
                    <Button on:click={() => modalStore.open('prepaid', 'modal', prepaid)} icon="ellipsis-v"/>
                </td>
            </tr>
        {/each}
    </tbody>
</Table>
